import React from 'react';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Organization from './Organization';
import Users from './Users';
import Groups from './Groups';
import Department from './Department';
import OrgTitle from './OrgTitle';
import Categories from './Categories';

const OrgTab = () => {

    const [value, setValue] = React.useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%', typography: 'body1' }}>
          <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleChange} aria-label="Org's">
                    <Tab label="Organization" value="1" />
                    <Tab label="User" value="2" />
                    <Tab label="Categories" value="3" />
                    <Tab label="Groups" value="4" />
                    <Tab label="Departments" value="5" />
                    <Tab label="Org Title" value="6" />                    
                </TabList>
                </Box>
                <TabPanel value="1">
                    <Organization />
                </TabPanel>
                <TabPanel value="2">
                    <Users/>
                </TabPanel>
                <TabPanel value="3">
                    <Categories/>
                </TabPanel>
                <TabPanel value="4">
                    <Groups />
                </TabPanel>
                <TabPanel value="5">
                    <Department />
                </TabPanel>
                <TabPanel value="6">
                    <OrgTitle/>
                </TabPanel>                 
            </TabContext>
        </Box>
    );
};
export default OrgTab;